import React, {useEffect, useRef} from "react";
import gsap from 'gsap';


import styles from "./Footer.module.scss";
import Image from "../components/Global/Image";
import etoroLogo from "../images/etoro-logo.svg";
import Block from "../components/Elements/Block";

export default function Footer() {
    return (
        <>
            <footer className={styles.Main}>
                <div className={styles.Mentions}>
                    <div className="container">
                        <p>
                            <a href="https://www.etoro.com/fr/stocks/trading-and-investing-in-stocks/" rel={'dofollow'} target={'_blank'}>
                                Investir en actions
                            </a>

                            &nbsp;&nbsp;&nbsp;&nbsp;

                            <a href="https://www.etoro.com/fr/investing/how-to-diversify-your-portfolio/" rel={'dofollow'} target={'_blank'}>
                                Diversifier son portefeuille
                            </a>

                            &nbsp;&nbsp;&nbsp;&nbsp;

                            <a href="https://www.etoro.com/fr/stocks/risk-management/" rel={'dofollow'} target={'_blank'}>
                                Gérer les risques
                            </a>

                            {/*
                            <strong>Mention légales : </strong>
                            <br/><br/>
                            Vous devriez demander l'avis d'un conseiller financier indépendant et agréé et vous assurer que vous avez l’appétence au risque, l'expérience et les connaissances pertinentes avant de décider de trader. En aucune circonstance eToro ne pourra être tenu responsable envers quelque personne ou entité que ce soit (a) des pertes ou dommages entièrement ou en partie causés par, résultant de, ou liés à des transactions sur des CFD ou (b) des dommages directs, indirects, spéciaux, consécutifs ou accidentels quels qu'ils soient.

                            <br/>
                            <br/>
                            Le trading avec eToro en suivant et/ou en copiant ou répliquant les trades d'autres traders implique un niveau élevé de risques, même si vous suivez ou copiez ou répliquez les actions des traders les plus performants. <br/>
                            Cela inclut le risque de suivre/copier les décisions de traders éventuellement inexpérimentés/non professionnels et le risque associé aux traders dont l'objectif, l'intention ultime, ou encore le statut financier, peuvent différer du vôtre.

                            <br/>
                            <br/>
                            Les performances passées d'un membre de la communauté d’eToro ne constituent par une indication fiable de ses performances futures. Les informations présentes dans la plateforme de trading social d'eToro sont générées par les membres de sa communauté et ne comportent pas de conseils ou de recommandations donnés par ou au nom d'eToro - Votre Réseau Social d’Investissement.
                             */}
                        </p>
                        <Image src={etoroLogo} classname={styles.Logo}/>
                    </div>
                </div>
            </footer>
        </>
    )
}
